// frontend/src/pages/user/UserProfilePage.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';

// AVATAR LİSTESİ
const AVATAR_OPTIONS = [
    '/avatar/default-avatar.png',
    '/avatar/avatar-1.png',
    '/avatar/avatar-2.png',
    '/avatar/avatar-3.png',
    '/avatar/avatar-4.png',
    '/avatar/avatar-5.png',
    '/avatar/avatar-6.png',
    '/avatar/avatar-7.png'
];

const UserProfilePage = () => {
    const { userInfo } = useAuth();
    const [formData, setFormData] = useState({
        name: '', email: '', phone: '', description: '', avatar: '', password: '', confirmPassword: ''
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);

    useEffect(() => {
        if (userInfo) {
            setFormData(prev => ({
                ...prev,
                name: userInfo.name || '',
                email: userInfo.email || '',
                phone: userInfo.phone || '',
                description: userInfo.description || '',
                avatar: userInfo.avatar || '/avatar/default-avatar.png'
            }));
        }
    }, [userInfo]);

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage(null);
        if (formData.password && formData.password !== formData.confirmPassword) {
            setMessage({ type: 'error', text: 'Şifreler eşleşmiyor!' }); return;
        }

        setLoading(true);
        try {
            const updateData = {
                name: formData.name, email: formData.email, phone: formData.phone,
                description: formData.description, avatar: formData.avatar
            };
            if (formData.password) updateData.password = formData.password;

            const { data } = await api.put(`/users/profile`, updateData);
            
            // LocalStorage'ı güncelle
            if(data) {
                const currentStorage = JSON.parse(localStorage.getItem('userInfo')) || {};
                const newUserInfo = { ...currentStorage, ...data };
                localStorage.setItem('userInfo', JSON.stringify(newUserInfo));
            }

            setMessage({ type: 'success', text: 'Profil güncellendi! Sayfa yenileniyor...' });
            setTimeout(() => window.location.reload(), 1500);

        } catch (error) {
            setMessage({ type: 'error', text: error.response?.data?.message || 'Hata oluştu.' });
        } finally {
            setLoading(false);
        }
    };

    // Avatar URL veya Default
    const avatarSrc = formData.avatar || '/avatar/default-avatar.png';

    return (
        <div className="max-w-4xl mx-auto text-text-primary pb-10">
            <h1 className="text-2xl font-bold mb-6">Profil Ayarları</h1>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                {/* SOL TARAF: ÖNİZLEME */}
                <div className="bg-surface p-6 rounded-xl shadow-lg border border-border text-center h-fit">
                    <img src={avatarSrc} alt="Avatar" className="w-24 h-24 mx-auto rounded-full object-cover border-4 border-background shadow-md mb-4" />
                    <h2 className="text-lg font-bold">{userInfo?.name}</h2>
                    <p className="text-text-secondary text-xs mt-1">{userInfo?.email}</p>
                </div>

                {/* SAĞ TARAF: FORM */}
                <div className="lg:col-span-2 bg-surface p-6 rounded-xl shadow-lg border border-border">
                    {message && (
                        <div className={`p-3 mb-4 rounded text-sm font-bold ${message.type === 'success' ? 'bg-green-500/20 text-green-500' : 'bg-red-500/20 text-red-500'}`}>
                            {message.text}
                        </div>
                    )}
                    <form onSubmit={handleSubmit} className="space-y-4">
                        
                        {/* AVATAR SEÇİMİ (YENİ) */}
                        <div>
                            <label className="text-xs font-bold text-text-secondary uppercase mb-2 block">Profil Resmi Seç</label>
                            <div className="flex flex-wrap gap-3 p-3 bg-background rounded-lg border border-border">
                                {AVATAR_OPTIONS.map((av, idx) => (
                                    <img 
                                        key={idx} 
                                        src={av} 
                                        onClick={() => setFormData({...formData, avatar: av})}
                                        alt={`Avatar ${idx}`}
                                        className={`w-12 h-12 rounded-full object-cover cursor-pointer border-2 transition-all hover:scale-110 ${formData.avatar === av ? 'border-primary scale-110' : 'border-transparent hover:border-gray-500'}`}
                                    />
                                ))}
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="text-xs font-bold text-text-secondary uppercase">Ad Soyad</label>
                                <input type="text" name="name" value={formData.name} onChange={handleChange} className="w-full bg-background border border-border rounded p-2 text-sm text-white focus:border-primary focus:outline-none" required />
                            </div>
                            <div>
                                <label className="text-xs font-bold text-text-secondary uppercase">Telefon</label>
                                <input type="text" name="phone" value={formData.phone} onChange={handleChange} className="w-full bg-background border border-border rounded p-2 text-sm text-white focus:border-primary focus:outline-none" />
                            </div>
                        </div>
                        <div>
                            <label className="text-xs font-bold text-text-secondary uppercase">Hakkımda</label>
                            <textarea name="description" value={formData.description} onChange={handleChange} rows="3" className="w-full bg-background border border-border rounded p-2 text-sm text-white focus:border-primary focus:outline-none"></textarea>
                        </div>
                        <div className="pt-4 border-t border-border">
                            <p className="text-xs font-bold text-primary mb-3">Şifre Değiştir (İsteğe Bağlı)</p>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <input type="password" name="password" value={formData.password} onChange={handleChange} className="w-full bg-background border border-border rounded p-2 text-sm text-white focus:border-primary focus:outline-none" placeholder="Yeni Şifre" />
                                <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} className="w-full bg-background border border-border rounded p-2 text-sm text-white focus:border-primary focus:outline-none" placeholder="Şifre Tekrar" />
                            </div>
                        </div>
                        <div className="flex justify-end pt-2">
                            <button type="submit" disabled={loading} className="px-6 py-2 bg-primary hover:bg-blue-600 text-white font-bold rounded shadow transition-colors text-sm disabled:opacity-50">
                                {loading ? 'Kaydediliyor...' : 'Kaydet'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UserProfilePage;